const SignIn = () => import('@/views/SignIn')

export default [
	{
		component: SignIn,
		name: 'signin',
		path: 'signin'
	}
]
